<script context="module">
    import { env } from '../Environment.svelte';

    export async function clientPurchaseCreate(store) {
        var PURCHASE_CREATE =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/v2/izziEnroll';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let extras = [];

        Array.prototype.push.apply(
            extras,
            store.requestedServices.channelExtras
        );
        Array.prototype.push.apply(
            extras,
            store.requestedServices.tvExtensionsExtras
        );
        Array.prototype.push.apply(extras, store.requestedServices.phoneExtras);
        Array.prototype.push.apply(
            extras,
            store.requestedServices.phoneExtensionsExtras
        );

        let orderType = store.requestedServices.deliveryType;

        let autoInstallOrder = {};

        if (orderType === 'SUCURSAL') {
            autoInstallOrder = {
                autoInstalacion: store.requestedServices.flagAutoinstalacion,
                tipoEntrega: 'SUCURSAL',
                sucursal: store.requestedServices.sucursalId,
            };
        } else if (orderType === 'DOMICILIO') {
            autoInstallOrder = {
                autoInstalacion: store.requestedServices.flagAutoinstalacion,
                tipoEntrega: 'DOMICILIO',
            };
        } else if (orderType === 'TECNICO') {
            autoInstallOrder = {
                autoInstalacion: store.requestedServices.flagAutoinstalacion,
                tipoEntrega: 'DOMICILIO',
            };
        }

        let stringAddress =
            store.requestedAddress.postalCode +
            '|' +
            store.requestedAddress.city +
            '|' +
            store.requestedAddress.suburb +
            '|' +
            store.requestedAddress.street +
            '|' +
            store.requestedAddress.externalNumber +
            '|' +
            (store.requestedAddress.internalNumber != null &&
            store.requestedAddress.internalNumber != undefined
                ? store.requestedAddress.internalNumber
                : '');

        let endpoint = PURCHASE_CREATE;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                stepSavedProspect: '',
                purchaseId: '',
                requestedAddress: {
                    stringAddress: stringAddress,
                    addressReference: store.requestedAddress.addressReference
                        ? store.requestedAddress.addressReference
                        : 'Sin Referencia',
                    postalCode: store.requestedAddress.postalCode,
                    state: store.requestedAddress.state,
                    betweenStreets1: store.requestedAddress.betweenStreets1
                        ? store.requestedAddress.betweenStreets1
                        : 'Sin Referencia',
                    betweenStreets2: store.requestedAddress.betweenStreets2
                        ? store.requestedAddress.betweenStreets2
                        : 'Sin Referencia',
                    addressId: store.requestedAddress.addressId,
                    housingUnit: store.requestedAddress.housingUnit,
                    billing: store.requestedAddress.billing,
                    billingPostalCode: store.requestedAddress.billing
                        ? store.requestedAddress.billingPostalCode
                        : null,
                    billingCity: store.requestedAddress.billing
                        ? store.requestedAddress.billingCity
                        : null,
                    billingSettlement: store.requestedAddress.billing
                        ? store.requestedAddress.billingSettlement
                        : null,
                    billingStreet: store.requestedAddress.billing
                        ? store.requestedAddress.billingStreet
                        : null,
                    billingExteriorNumber: store.requestedAddress.billing
                        ? store.requestedAddress.billingExteriorNumber
                        : null,
                    billingInteriorNumber: store.requestedAddress.billing
                        ? store.requestedAddress.billingInteriorNumber
                        : null,
                    billingState: store.requestedAddress.billing
                        ? store.requestedAddress.billingState
                        : null,
                    latitude: store.requestedAddress.latitude,
                    longitude: store.requestedAddress.longitude,
                },
                personalDetails: {
                    nombre: store.personalDetails.nombre,
                    segundoNombre: store.personalDetails.segundoNombre,
                    apPaterno: store.personalDetails.apPaterno,
                    apMaterno: store.personalDetails.apMaterno,
                    numeroCelular: store.personalDetails.numeroCelular,
                    curp: store.personalDetails.curp,
                    pasaporte: store.personalDetails.pasaporte,
                    correo: store.personalDetails.correo,
                    password: store.personalDetails.password,
                    portability: store.personalDetails.portabilityNumber,
                    giroNegocio: store.personalDetails.giroNegocio,
                    razonSocial: store.personalDetails.razonSocial,
                    rfc: store.personalDetails.rfc
                        ? store.personalDetails.rfc.toUpperCase()
                        : store.personalDetails.rfc,
                    codigoCfdi: store.personalDetails.codigoCfdi,
                    regimenFiscal: store.personalDetails.regimenFiscal,
                    codigoVerificacionCel:
                        store.personalDetails.codigoVerificacion,
                },
                salesChannel: 'WEB',
                offNetSky: store.requestedServices.isSky,
                offNetIzzi:
                    store.requestedAddress.offnetIzziCoverage &&
                    store.requestedAddress.offnetCoverage &&
                    !store.requestedServices.isSky,
                autoInstalacion: store.requestedServices.flagAutoinstalacion,
                autoInstallOrder: autoInstallOrder,
                vendorInfo: {
                    vendedorMaster: false,
                },
                dateInstallationRequired: store.requestedServices
                    .flagAutoinstalacion
                    ? false
                    : store.requestedServices.isSpMovil
                      ? store.requestedServices.izzimovil.some(
                            (item) => item.deliveryType === 'TECNICO'
                        )
                      : true,
                isOnlineSale: true,
                acompletarIzziCombo: false,
                banderaSp: false,
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                } else {
                    return response.json();
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function clientAddOffers(processId, store) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/v2/submitOffer';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);
        let extras = [];

        Array.prototype.push.apply(
            extras,
            store.requestedServices.channelExtras
        );
        Array.prototype.push.apply(
            extras,
            store.requestedServices.tvExtensionsExtras
        );
        Array.prototype.push.apply(extras, store.requestedServices.phoneExtras);
        Array.prototype.push.apply(
            extras,
            store.requestedServices.phoneExtensionsExtras
        );

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                processId: processId,
                requestedServices: {
                    product: store.requestedServices.productId,
                    productName: store.requestedServices.product.nombreCode,
                    negocios:
                        store.requestedServices.product.categoriapaquete ==
                        'NEGOCIOSMODULAR'
                            ? true
                            : false,
                    termExemptionPrice:
                        store.requestedServices.product.precioExencion,
                    extras: processExtras(extras, store),
                    priceToPay: ensureDecimal(store.requestedServices.total),
                    vel: store.requestedServices.product.vel,
                },
                salesChannel: 'WEB',
                offNetSky: store.requestedServices.isSky,
                offNetIzzi:
                    store.requestedAddress.offnetIzziCoverage &&
                    store.requestedAddress.offnetCoverage &&
                    !store.requestedServices.isSky,
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.status;
                } else if (response.status === 500) {
                    return 500;
                } else if (response.status === 409) {
                    return 409;
                } else {
                    throw new Error(
                        'Error al consumir el servicio purchaseCreate'
                    );
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    function ensureDecimal(value) {
        return value.toString().includes('.') ? value : value + '.0';
    }

    export async function clientPurchaseProcess(processId) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/v2/order?processId=' +
            processId;
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 500) {
                    return {
                        code: 500,
                        message:
                            'En este momento no podemos procesar tu solicitud, por favor intenta más tarde.',
                    };
                } else {
                    throw new Error(
                        'Error al consumir el servicio purchaseCreate'
                    );
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function clientInstallationDates(processId) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/v2/getCapacity?processId=' +
            processId;
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error(
                        'Error al consumir el servicio purchaseCreate'
                    );
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function clientPurchaseFinalize(store) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/v2/submitCapacity';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                processId: store.purchaseStatus.processId,
                schedule: {
                    cvTimeslot:
                        store.requestedServices.isSpMovil == false
                            ? store.purchaseStatus.installationTime
                            : '',
                    requestedShipDate:
                        store.requestedServices.isSpMovil == false
                            ? store.purchaseStatus.installationDate
                            : '',
                },
                paymentType: store.purchaseStatus.paymentType,
                termExemption: false,
                installationExpress: store.purchaseStatus.installationExpress,
                installationComments: '',
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return;
                } else {
                    return response.json();
                }
            })
            .then((response) => {
                return response;
            });
        return await resp;
    }

    export async function clientPurchaseCancel(store, uri) {
        var PURCHASE_CANCEL =
            env[env.stage].api.url +
            'apikey/izzi/arc/camunda/purchase/cancelOrder';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let stringInternalNumber =
            store.requestedAddress.internalNumber === ''
                ? '0'
                : store.requestedAddress.internalNumber;
        let endpoint = PURCHASE_CANCEL;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                requestedAddress: {
                    stringAddress:
                        store.requestedAddress.street +
                        ', ' +
                        store.requestedAddress.externalNumber +
                        ', ' +
                        stringInternalNumber +
                        ', ' +
                        store.requestedAddress.suburb +
                        ', ' +
                        store.requestedAddress.state +
                        ', ' +
                        store.requestedAddress.postalCode,
                },
                personalDetails: {
                    nombre: store.personalDetails.nombre,
                    segundoNombre: store.personalDetails.segundoNombre,
                    apPaterno: store.personalDetails.apPaterno,
                    apMaterno: store.personalDetails.apMaterno,
                    numeroCelular: store.personalDetails.numeroCelular,
                    correo: '',
                },
                salesChannel: store.requestedServices.product.title,
            }),
        };

        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                } else {
                    return response.json();
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    function processExtras(extras, store) {
        let extrasAuxiliar = new Array();
        let delivery = store.requestedServices.deliveryType;
        let plansByTitleMovil = Object.groupBy(
            store.requestedServices.izzimovil,
            ({ title }) => title
        );
        if (extras != undefined && extras != null) {
            extras.forEach((element) => {
                if (element.portability) {
                } else {
                    extrasAuxiliar.push({
                        extId: element.extId,
                        nuevaCantidad: element.nuevaCantidad,
                        combo: element.combo,
                    });
                }
            });
        }

        if (store.requestedServices.izzimovil.length > 0) {
            for (const key in plansByTitleMovil) {
                const items = plansByTitleMovil[key];
                let data = getDataByPlan(items);
                extrasAuxiliar.push({
                    extId: items[0].plan.extra
                        ? items[0].plan.extId
                        : items[0].plan.paqId,
                    extra: {
                        title: items[0].plan.extra
                            ? items[0].plan.extra.title
                            : items[0].plan.title,
                    },
                    nuevaCantidad: items.length,
                    combo: false,
                    tipoEntrega: delivery,
                    sucursalId:
                        delivery === 'SUCURSAL'
                            ? store.requestedServices.sucursalId
                            : 'N/A',
                    portabilidadMovil: data.portabilityList,
                    imei: '',
                });
            }
        }
        return extrasAuxiliar;
    }

    const getDataByPlan = (elements) => {
        let deliveryTypeList = elements.reduce(
            (accumulator, item, index) =>
                accumulator + (index == 0 ? '' : ',') + item.deliveryType,
            ''
        );
        let sucursalIdsList = elements.reduce(
            (accumulator, item, index) =>
                accumulator +
                (index == 0 ? '' : ',') +
                (item.branch ? item.branch.warehouse : 'N/A'),
            ''
        );
        let portabilityList = elements.reduce(
            (accumulator, item, index) =>
                accumulator + (index == 0 ? '' : ',') + item.portability,
            ''
        );
        let imeiList = elements.reduce(
            (accumulator, item, index) =>
                accumulator + (index == 0 ? '' : ',') + item.imei,
            ''
        );

        return { deliveryTypeList, sucursalIdsList, portabilityList, imeiList };
    };
</script>
